import React, { useRef, useState } from "react";
import hero1 from "../../images/hero/image-2.png";
import hero2 from "../../images/hero/video-image.jpg";
import shape from "../../images/hero/flower.png";

const YT_BASE =
  "https://www.youtube.com/embed/OUB6zKc-Tos";

const Hero2: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const openVideo = () => {
    setIsOpen(true);
    requestAnimationFrame(() => {
      if (iframeRef.current) iframeRef.current.src = YT_BASE;
    });
  };

  const closeVideo = () => {
    if (iframeRef.current) {
      iframeRef.current.src = "about:blank";
    }
    setIsOpen(false);
  };

  return (
    <section className="wpo-hero-static-s2">
      <div className="wrapper">
        <h2 className="wow fadeInUp" data-wow-duration="1200ms">
          FOREVER<span></span> AFTER
        </h2>

        <div className="hero-content wow fadeInUp" data-wow-delay="0.2s">
          <p>
            Hi, Welcome to our Big Day in <span>June 15, 2026.</span> Together,
            let's create a remarkable journey where our dreams become realities.
          </p>

          <div className="hero-bottom-image wow fadeInUp" data-wow-delay="0.4s">
            <img src={hero2} alt="hero" />
            <div className="video-wrap">
              <button onClick={openVideo} className="video-btn" aria-label="Play video">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" fill="none">
                  <path
                    d="M30.3422 13.4613L9.67032 0.71872C8.17475 -0.202014 6.36657 -0.240296 4.83334 0.616317C3.3001 1.47279 2.38477 3.03283 2.38477 4.78905V30.1581C2.38477 32.8136 4.52442 34.9856 7.15421 34.9999C7.99742 34.9999 8.85383 34.7423 9.65371 34.2543C10.2972 33.8617 10.5005 33.0218 10.108 32.3784C9.71537 31.7349 8.87536 31.5316 8.2321 31.9242C7.85797 32.1523 7.49259 32.2704 7.16891 32.2703C6.17667 32.2649 5.11429 31.4149 5.11429 30.1582V4.78912C5.11429 4.03573 5.50695 3.36669 6.16457 2.99926C6.82226 2.63183 7.59779 2.64824 8.23853 3.04274L28.9105 15.7853C29.5318 16.1678 29.8874 16.8057 29.8859 17.5354C29.8844 18.265 29.5262 18.9014 28.9015 19.2826L13.9556 28.4338C13.3127 28.8274 13.1106 29.6676 13.5043 30.3104C13.8978 30.9532 14.738 31.1553 15.3809 30.7617L30.325 21.6116C31.7558 20.7388 32.6121 19.2171 32.6155 17.5408C32.6189 15.8648 31.7688 14.3396 30.3422 13.4613Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* circle animation */}
      <div className="hero-circle">
        <div className="circle-content wow fadeInUp" data-wow-delay="0.2s">
          <div className="rotate-anm">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <path
                  id="circle1"
                  d="M 50, 50
                     m -37, 0
                     a 37,37 0 1,1 74,0
                     a 37,37 0 1,1 -74,0"
                />
              </defs>
              <text>
                <textPath href="#circle1">you are invited</textPath>
              </text>
            </svg>
            <div className="flower">
              <img src={shape} alt="flower" />
            </div>
          </div>
          <div className="circle-big"></div>
          <div className="circle-small"></div>
        </div>
      </div>

      <div className="overlay-image">
        <img src={hero1} alt="hero background" />
      </div>

      {/* Modal: simple, dependency-free */}
      <div
        role="dialog"
        aria-modal={isOpen}
        className="video-popup-overlay"
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.85)",
          display: isOpen ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
        onClick={closeVideo}
      >
        <div
          className="video-popup"
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "relative",
            width: "min(900px, 90vw)",
            aspectRatio: "16 / 9",
            background: "#000",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
          }}
        >
          <iframe
            ref={iframeRef}
            title="Wedding Video"
            width="100%"
            height="100%"
            src="about:blank"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            frameBorder={0}
          />
          <button
            onClick={closeVideo}
            aria-label="Close video"
            style={{
              position: "absolute",
              top: 10,
              right: 14,
              background: "transparent",
              color: "#fff",
              border: 0,
              fontSize: 24,
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero2;
